"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceButton = void 0;
const consts_1 = require("../../consts");
const GameplayUtils_1 = require("../GameplayUtils");
const ChoiceElement_1 = require("../../webComponents/ChoiceElement");
const fixWebpackAndRemoveMe_1 = require("../../img/fixWebpackAndRemoveMe");
const Analytics_1 = require("../../models/Analytics");
class ChoiceButton {
    constructor(scene, getDevicePixelRatio, choicesController, isMultiplayer, choiceIndex) {
        this.isRawText = false;
        this.isVisibleText = true;
        this.isHeartsDisabled = false;
        this.isTraitsHidden = true;
        this.isDisabled = false;
        this.cachedBoundsData = false;
        this.text = '';
        this.choiceIndex = 1;
        this.tempTextureId = "";
        this._isAnalyticsVisible = false;
        this._analyticsViewType = Analytics_1.AnalyticsViewType.HIDE;
        this.gameplayScene = scene;
        this.getDevicePixelRatio = getDevicePixelRatio;
        this.canvasWidth = scene.cameras.main.width;
        this.canvasHeight = scene.cameras.main.height;
        this.isRawText = false;
        this.clickButton = this.clickButton.bind(this);
        this.choicesController = choicesController;
        this.choiceIndex = choiceIndex;
        this._isMultiplayer = isMultiplayer;
    }
    init(props, clickCallback) {
        const { text, goto, costType, cost } = props;
        this.answer = props;
        this.clickCallback = clickCallback;
        this.goto = goto;
        this.text = text;
        this.cost = cost;
        this.costType = costType;
        this.createChoiceButtonFromCSS();
    }
    uninit() {
        this.destroy();
    }
    destroy() {
        var _a;
        if (!this.choiceElement) {
            return;
        }
        try {
            (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.removeChild(this.choiceElement);
        }
        catch (e) {
        }
        this.choiceElement.cleanShadowRoot();
    }
    setSelectedState(isSelected = false) {
        var _a;
        (_a = this.choiceElement) === null || _a === void 0 ? void 0 : _a.setIsSelected(isSelected);
    }
    setIsDisabled(isDisabled = false) {
        this.isDisabled = isDisabled;
    }
    setIsRawText(isRawText = false) {
        this.isRawText = isRawText;
    }
    setIsVisibleText(isVisibleText = true) {
        this.isVisibleText = isVisibleText;
    }
    createChoiceButtonFromCSS() {
        var _a;
        if (!this.answer) {
            return;
        }
        if (!this.choicesController) {
            return;
        }
        // const assetsPath = this.choicesController.textBubbleController?.localAssetsPath ?? "../assets/";
        const globalStyles = this.choicesController.getChoiceButtonCss();
        const { special_icon, costType } = this.answer;
        // add icon on the left side of button
        const iconDiv = special_icon
            ? `<div class="choice-btn-icon"></div>`
            : '';
        // add disabled status (ex: when user select button)
        const disabledValue = (this.isDisabled || this.answer.isDisabled) ? `disabled="disabled"` : '';
        // add cost div with icon on the right side of button
        const costDiv = costType === consts_1.COST_TYPE.HEART
            ? `<div class="choice-cost-icon icon-${costType}"></div>
                <div class="choice-cost-inside-value">${this.cost}</div>`
            : '';
        const realText = this.isRawText
            ? this.text
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
            : this.text;
        let choiceDebugText = '';
        if (this.answer.isChoiceMemoryDebug) {
            if (this.answer.isHidden) {
                choiceDebugText = 'BUTTON IS HIDDEN';
            }
            else if (this.answer.isDisabled) {
                choiceDebugText = 'BUTTON IS DISABLED';
            }
        }
        const analyticsHtml = `
            <div class="analytics-box-wrapper">
                <div class="analytics-box analytics-box-top">
                    <span>0</span>
                    <img src="${fixWebpackAndRemoveMe_1.analyticsFriendIcon}" class="analytics-icon"/>
                </div>
                <div class="analytics-box analytics-box-bottom">
                    <span>0</span>
                    <img src="${fixWebpackAndRemoveMe_1.analyticsFavouriteIcon}" class="analytics-icon"/>
                </div>
            </div>
        `;
        const html = `
            <div class="choice-container">
                <button class="choice-border" ${disabledValue}>
                    <div class="choice-btn">
                        <div class="choice-icon">
                            ${iconDiv}
                        </div>
                        <div class="choice-text">
                            <div class="choice-text-inside">${realText}</div>
                        </div>
                        <div class="choice-cost">
                            <div class="choice-cost-inside">
                                ${costDiv}
                            </div>
                        </div>
                    </div>
                    <div class="choice-multiplayer-ui"></div>
                    <div class="choice-winning-checkmark hidden">
                        <img src="${fixWebpackAndRemoveMe_1.iconPlayerChoice}" />
                    </div>
                </button>
                <div class="choice-debug">${choiceDebugText}</div>
                <div class="choice-analytics">${analyticsHtml}</div>
            </div>
        `;
        this.choiceElement = new ChoiceElement_1.ChoiceElement({
            template: html,
            styles: globalStyles,
        });
        this.choiceElement.style.setProperty('--trait-color', this.answer.trait_color);
        this.choiceElement.style.setProperty('--button-num', `${this.choiceIndex + 1}`);
        this.choiceElement.classList.add(`type-${this.answer.type}`);
        // TODO: move .is-multiplayer to the top domLayer
        this.choiceElement.classList.toggle('is-multiplayer', this._isMultiplayer);
        this.choiceElement.classList.toggle('is-analytics', false);
        this.choiceElement.classList.add(`cost-${this.answer.costType}`);
        if (this.answer.isHidden) {
            this.choiceElement.classList.add('is-hidden');
        }
        else if (this.answer.isDisabled) {
            this.choiceElement.classList.add('is-disabled');
        }
        if (this.answer.isChoiceMemoryDebug) {
            this.choiceElement.classList.add('is-choice-memory-debug');
        }
        (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.appendChild(this.choiceElement);
        const choiceContainer = this.choiceElement.getChoiceButton();
        if (choiceContainer) {
            choiceContainer.addEventListener('click', () => {
                var _a, _b;
                if (((_a = this.answer) === null || _a === void 0 ? void 0 : _a.isDisabled) || ((_b = this.answer) === null || _b === void 0 ? void 0 : _b.isHidden)) {
                    return;
                }
                this.clickButton();
            });
        }
        this.choiceElement.classList.toggle('invisible-text', !this.isVisibleText);
        this.updateHtmlToApplyDifferentStyles();
    }
    refreshStyle() {
        if (!this.choicesController || !this.choiceElement) {
            return;
        }
        const globalStyles = this.choicesController.getChoiceButtonCss();
        this.choiceElement.styles = globalStyles;
        this.updateHtmlToApplyDifferentStyles();
    }
    updateHtmlToApplyDifferentStyles() {
        if (!this.answer || !this.choiceElement) {
            return;
        }
        const { type, bonusContent, special_icon, gold_border, trait_fill, is_author } = this.answer;
        const choiceBtn = this.choiceElement.getChoiceButton();
        const choiceBorder = this.choiceElement.getChoiceBorder();
        if (choiceBtn) {
            // if (this.isHeartsDisabled) {
            //     if (type === ANSWER_TYPES.ROMANTIC || type === ANSWER_TYPES.EROTIC) {
            //         choiceBtn.classList.add('grid1');
            //     } else if (bonusContent) {
            //         choiceBtn.classList.add('grid2');
            //     } else {
            //         choiceBtn.classList.add('grid3');
            //     }
            // }
            if (special_icon) {
                if ((type === consts_1.ANSWER_TYPES.ROMANTIC || type === consts_1.ANSWER_TYPES.EROTIC) && !bonusContent) {
                    choiceBtn.classList.add('extra-bg-color');
                }
                else if (this.isTraitsHidden && type !== consts_1.ANSWER_TYPES.ROMANTIC && type !== consts_1.ANSWER_TYPES.EROTIC) {
                    choiceBtn.classList.add('extra-border-color');
                }
            }
            if (((type === consts_1.ANSWER_TYPES.ROMANTIC || type === consts_1.ANSWER_TYPES.EROTIC) && bonusContent) || gold_border) {
                choiceBtn.classList.add('golden-border');
                choiceBorder === null || choiceBorder === void 0 ? void 0 : choiceBorder.classList.add('golden-border');
            }
        }
        const choiceText = this.choiceElement.getChoiceText();
        if (choiceText) {
            if (bonusContent) {
                choiceText.classList.add('black-color');
                choiceText.classList.add('bonus-background');
                if (this.isHeartsDisabled) {
                    choiceText.classList.add('hearts-disabled');
                }
            }
            else if (trait_fill) {
                choiceText.classList.add('black-color');
                choiceText.classList.add('extra-bg-color');
            }
            else if (this.isTraitsHidden) {
                choiceText.classList.add('white-color');
                choiceText.classList.add('extra-bg-color');
            }
            else if (this._isMultiplayer) {
                choiceText.classList.add('white-color');
                choiceText.classList.add('multiplayer-background');
            }
        }
        const choiceIcon = this.choiceElement.getChoiceIcon();
        if (choiceIcon) {
            if (!this.isHeartsDisabled || type === consts_1.ANSWER_TYPES.ROMANTIC || type === consts_1.ANSWER_TYPES.EROTIC) {
                choiceIcon.classList.add('extra-size');
            }
            else {
                choiceIcon.classList.add('default-size');
            }
            choiceIcon.classList.add('extra-bg-color');
            if (this.isTraitsHidden) {
                choiceIcon.classList.add('traits-hidden');
            }
            else {
                choiceIcon.classList.add('traits-shown');
            }
            if (this.isTraitsHidden && bonusContent) {
                choiceIcon.classList.add('bonus-background');
            }
        }
        const choiceCost = this.choiceElement.getChoiceCost();
        if (choiceCost) {
            if (!this.isHeartsDisabled) {
                choiceCost.classList.add('hearts-disabled');
            }
            else if (bonusContent || type === consts_1.ANSWER_TYPES.ROMANTIC || type === consts_1.ANSWER_TYPES.EROTIC) {
                choiceCost.classList.add('visibility-hidden');
            }
            if (this.isTraitsHidden && this._isMultiplayer) {
                choiceCost.classList.add('extra-bg-color');
                choiceCost.classList.add('extra-border-radius');
            }
        }
        const choiceCostIcon = this.choiceElement.getChoiceCostIcon();
        if (choiceCostIcon) {
            if (this.costType !== consts_1.COST_TYPE.FREE) {
                switch (this.costType) {
                    case consts_1.COST_TYPE.HEART:
                        choiceCostIcon.classList.add('heart-type');
                        break;
                    case consts_1.COST_TYPE.COIN:
                        choiceCostIcon.classList.add('heart-coin');
                        break;
                    case consts_1.COST_TYPE.KEY:
                        choiceCostIcon.classList.add('heart-key');
                        break;
                }
                if (is_author) {
                    choiceCostIcon.classList.add('is-author');
                }
            }
        }
        const choiceIconInside = this.choiceElement.getChoiceIconInside();
        if (choiceIconInside) {
            if (this.isTraitsHidden && this.costType !== consts_1.COST_TYPE.FREE) {
                choiceIconInside.classList.add('extra-bg-color');
            }
        }
    }
    enableInteractivity() {
        if (!this.choiceElement) {
            return;
        }
        this.choiceElement.setIsEnabled(true);
    }
    disableInteractivity() {
        if (!this.choiceElement) {
            return;
        }
        this.choiceElement.setIsEnabled(false);
    }
    getAnswerNum() {
        return this.answer.num;
    }
    setExtraSettings(extraSettings) {
        const { isHeartsDisabled, isTraitsHidden } = extraSettings;
        this.extraSettings = extraSettings;
        this.isHeartsDisabled = isHeartsDisabled;
        this.isTraitsHidden = isTraitsHidden;
    }
    clickButton() {
        var _a;
        (_a = this.clickCallback) === null || _a === void 0 ? void 0 : _a.call(this, this.answer);
    }
    calcElementsBoundsData() {
        // this.cachedBoundsData = {
        //     x: 0,// textfieldBoundsFinal.x/dPR,
        //     y: 0,// textfieldBoundsFinal.y/dPR,
        //     width: 0,//widthAll,
        //     height: 0,//heightAll,
        //     fontSize: 0,//roundUpFontSize,
        //     fontStyle: '500',// this.fontWeight,
        //     paddingLeft: 0,//paddingLeft,
        //     paddingRight: 0,//paddingRight,
        //     paddingTop: 0,//(this.textPadddingVertical ?? 0)/dPR,
        //     paddingBottom: 0,//(this.textPadddingVertical ?? 0)/dPR,
        //     textAlign: 'left', //this.textAlign,
        //     textColor: '#fff',//this.textColor,
        //     lineSpacing: 0,//this.getLineSpacing()/dPR,
        //     fullElementBounds: {
        //         x: 0,//(this.parentContainerPosX + this.x)/ dPR,
        //         y: 0,//(this.parentContainerPosY + this.y)/ dPR,
        //         width: 0,//(this.backgroundWidth ?? 0)/ dPR,
        //         height: 0,//(this.backgroundHeight ?? 0) / dPR
        //     }
        // };
        var _a, _b;
        this.cachedBoundsData = (_b = (_a = this.choiceElement) === null || _a === void 0 ? void 0 : _a.calculateBounds()) !== null && _b !== void 0 ? _b : false;
    }
    getElementBoundsData() {
        return this.cachedBoundsData;
    }
    createSelectedCheckmark() {
        if (!this.choiceElement) {
            return;
        }
        this.choiceElement.classList.toggle('winning-check-mark-visible', true);
    }
    createAvatar(avatarUrl) {
        if (!this.choiceElement) {
            return;
        }
        const avatarImage = document.createElement('img');
        avatarImage.className = 'choice-avatar';
        avatarImage.src = avatarUrl;
        const multiplayerUIDiv = this.choiceElement.getMultiplayerContainer();
        if (!multiplayerUIDiv) {
            return;
        }
        multiplayerUIDiv.appendChild(avatarImage);
    }
    createVotesCounter(audienceCount = 0, broadcasterPlayersCount = 0) {
        // prevent adding counter if not enough votes
        if (audienceCount === 0) {
            return;
        }
        if (!this.choiceElement) {
            return;
        }
        const i18n = (0, GameplayUtils_1.getI18n)();
        let audienceCountStr = new Intl.NumberFormat(i18n).format(audienceCount);
        if (broadcasterPlayersCount > 0) {
            audienceCountStr = `+${audienceCountStr}`;
        }
        const multiplayerUIDiv = this.choiceElement.getMultiplayerContainer();
        if (!multiplayerUIDiv) {
            return;
        }
        ;
        const voteCounterHTML = document.createElement('div');
        voteCounterHTML.classList.add('choice-votes-counter');
        voteCounterHTML.textContent = audienceCountStr;
        if (audienceCount < 10) {
            voteCounterHTML.classList.add('one-digit');
        }
        multiplayerUIDiv.appendChild(voteCounterHTML);
    }
    updateText(text) {
        if (text === this.text) {
            return;
        }
        this.text = text;
        if (!this.choiceElement) {
            return;
        }
        this.choiceElement.mainText = text;
    }
    displayAnalytics(analyticsData) {
        this._analyticsData = analyticsData;
        this._isAnalyticsVisible = true;
        if (this._analyticsViewType === Analytics_1.AnalyticsViewType.HIDE) {
            // change view type when called for the first time (view type is HIDE by default)
            this.changeViewType(Analytics_1.AnalyticsViewType.COUNTS);
        }
        else {
            this.updateAnalyticsDisplayedData();
        }
        this.updateAnalyticsVisibility();
    }
    hideAnalytics() {
        this._isAnalyticsVisible = false;
        this.updateAnalyticsVisibility();
    }
    changeViewType(analyticsViewType) {
        if (this._analyticsViewType === Analytics_1.AnalyticsViewType.COUNTS) {
            this._isAnalyticsVisible = false;
            this.updateAnalyticsVisibility();
            return;
        }
        this._analyticsViewType = analyticsViewType;
        this.updateAnalyticsDisplayedData();
    }
    updateAnalyticsDisplayedData() {
        if (!this._analyticsData) {
            return;
        }
        if (!this.choiceElement) {
            return;
        }
        if (this.choiceElement.analyticsBoxBottomText) {
            this.choiceElement.analyticsBoxBottomText.textContent = this._analyticsData.hearts.toString();
        }
        let topAnalyticsValue = "";
        if (this._analyticsViewType === Analytics_1.AnalyticsViewType.COUNTS) {
            topAnalyticsValue = this._analyticsData.users.toString();
        }
        else if (this._analyticsViewType === Analytics_1.AnalyticsViewType.PERCENTAGE) {
            topAnalyticsValue = `${this._analyticsData.percent_users.toString()}%`;
        }
        if (this.choiceElement.analyticsBoxTopText) {
            this.choiceElement.analyticsBoxTopText.textContent = topAnalyticsValue;
        }
    }
    updateAnalyticsVisibility() {
        if (!this.choiceElement) {
            return;
        }
        this.choiceElement.classList.toggle('is-analytics', this._isAnalyticsVisible);
    }
}
exports.ChoiceButton = ChoiceButton;
